import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  path?: string;
}

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  crumbs: Crumb[];
}

export default function PageHeader({ title, subtitle, crumbs }: PageHeaderProps) {
  return (
    <section className="pt-24 md:pt-32 pb-10 md:pb-14 bg-background-100/70 border-b border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <nav className="mb-5 flex flex-wrap items-center gap-1.5 text-sm text-foreground-600" aria-label="面包屑">
          {crumbs.map((crumb, i) => (
            <span key={crumb.label} className="flex items-center gap-1.5">
              {i > 0 && <i className="ri-arrow-right-s-line text-foreground-400"></i>}
              {crumb.path ? (
                <Link to={crumb.path} className="hover:text-primary-700 transition-colors whitespace-nowrap">
                  {crumb.label}
                </Link>
              ) : (
                <span className="text-foreground-950 font-medium">{crumb.label}</span>
              )}
            </span>
          ))}
        </nav>
        <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">{title}</h1>
        {subtitle && (
          <p className="mt-3 max-w-2xl text-sm md:text-base leading-7 text-foreground-700">{subtitle}</p>
        )}
      </div>
    </section>
  );
}